import StorageManager from '../util/StorageManager'

const STORAGE_KEY = 'OLPHEN_ACCESS_TOKEN'

// 写真展公開サイト側では、認証処理は実施しないため、固定のトークンを利用することとなった
const TOKEN = process.env.VUE_APP_TOKEN

/**
 * トークン情報を扱うためのwrapperクラス
 */
class TokenUtil {
  /**
   * 保存
   * @param {*} val
   */
  static set (val) {
    StorageManager.setItem(STORAGE_KEY, val)
  }

  /**
   * 取得
   */
  static get () {
    // 公開用APIのトークンを返す
    return (TOKEN)
    // return StorageManager.getItem(STORAGE_KEY)
  }

  /**
   * トークンの削除
   */
  static remove () {
    StorageManager.removeItem(STORAGE_KEY)
  }

  /**
   * ログイン状態の確認
   */
  static isLogin () {
    return !!StorageManager.getItem(STORAGE_KEY)
  }
}

export default TokenUtil
